import { useEffect, useState } from 'react';

/**
 * The current time, read once when the component mounts, so every render of it
 * agrees on what "now" is. With `tickMs` the reading is refreshed on that
 * interval, for a clock that is meant to keep running on screen.
 */
export function useNow(tickMs?: number): Date {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    if (tickMs === undefined) {
      return;
    }
    const timer = window.setInterval(() => setNow(new Date()), tickMs);

    return () => window.clearInterval(timer);
  }, [tickMs]);

  return now;
}
